/** Brand corner — the "V" mark + Backoffice wordmark (mirrors the mockup). */
export function Brand() {
    return (
        <div className="flex items-center gap-2.5">
            <div className="flex size-[30px] items-center justify-center rounded-lg bg-gradient-to-br from-brand to-brand-700 text-base font-bold text-white">
                V
            </div>
            <div className="text-[15px] font-semibold leading-tight tracking-tight text-gray-900">
                Backoffice
                <span className="block text-[11px] font-medium text-gray-500">
                    Veevart Internal
                </span>
            </div>
        </div>
    );
}
